import { trackForwardedComponent } from '../../util/trackComponent.js';
import { SelectionListBox } from './SelectionListBox.js';
import { VirtualizedSelectionListBox } from './VirtualizedSelectionListBox.js';
export { Section as SelectionListSection } from '@react-stately/collections';
export { SelectionListItem } from './components/SelectionListItem/external.js';
import './types.js';

SelectionListBox.displayName = 'SelectionListBox';
var SelectionListBoxWithTracking = trackForwardedComponent(SelectionListBox, {
  addWrapper: true
});
VirtualizedSelectionListBox.displayName = 'VirtualizedSelectionListBox';
var VirtualizedSelectionListBoxWithTracking = trackForwardedComponent(VirtualizedSelectionListBox, {
  addWrapper: true
});

export { SelectionListBoxWithTracking as SelectionListBox, VirtualizedSelectionListBoxWithTracking as VirtualizedSelectionListBox };
//# sourceMappingURL=external.js.map
